export const validateName = (name) => {
    if (!name || name.trim() === '') {
        return false;
    }
    
    // Check if name contains at least one alphanumeric character
    const hasAlphanumeric = /[a-zA-Z0-9]/.test(name);
    return hasAlphanumeric;
};

export const getNameValidationMessage = (name, selectedVibe) => {
    if (!selectedVibe) {
        return '';
    }
    
    // Only show message if user has typed something but it's invalid
    if (name && name.trim() !== '' && !validateName(name)) {
        return 'Please add a name';
    }
    
    return '';
};